import { Box, Button } from "@mui/material";
import MultiSelect from "components/ui/multiSelect";
import getInitialvalues from "features/invoices/invoices/utils/filterInitialValues";
import { useFormik } from "formik";
import * as yup from "yup";
import { invoiceStatuses } from "../table/MainTableRow";
import useQueries from "hooks/useQueries";

const MainScreenFilter = ({
  assignees,
  setReload,
  setFilters,
  setPagination,
  pagination,
  filters,
  isFiltering,
  projects,
  intakes,
  customers,
}) => {
  const { setQueries } = useQueries();
  const initialValues = getInitialvalues(filters);

  const validationSchema = yup.object({});
  const onSubmit = async (data) => {
    setFilters({ ...filters, ...data });
    setPagination({ ...pagination, current_page: 1 });
    setReload((pre) => !pre);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const resetForm = () => {
    const emptyFilter = {};
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        emptyFilter[key] = [];
      } else {
        emptyFilter[key] = null;
      }
    }
    setQueries({}); // Clear queries in URL
    formik.setValues(emptyFilter);
    setFilters({});
    setReload((pre) => !pre);
  };

  return (
    <Box
      p="15px 20px 5px"
      sx={{
        borderTop: "1px solid #efefef",
        bgcolor: "#fff",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
        gap: "18px",
      }}
    >
      <MultiSelect
        options={invoiceStatuses}
        label="Statuses"
        value={formik?.values?.status}
        onChange={(value) => formik.setFieldValue("status", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />

      <MultiSelect
        options={customers}
        label="Customers"
        value={formik?.values?.customer_id}
        onChange={(value) => formik.setFieldValue("customer_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <MultiSelect
        options={projects}
        label="Projects"
        value={formik?.values?.project_id}
        onChange={(value) => formik.setFieldValue("project_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <MultiSelect
        options={assignees}
        label="Assignees"
        value={formik?.values?.user_id}
        onChange={(value) => formik.setFieldValue("user_id", value)}
        selectProps={{
          id: "user_id",
          label: "name",
        }}
      />
      <MultiSelect
        options={intakes}
        label="Intakes"
        value={formik?.values?.intake_id}
        onChange={(value) => formik.setFieldValue("intake_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
      >
        <Button
          variant="solid"
          onClick={formik.submitForm}
          disabled={!formik.dirty}
        >
          Filter
        </Button>
        <Button
          variant="outlined"
          disabled={!isFiltering()}
          onClick={resetForm}
        >
          Reset Filter
        </Button>
      </Box>
    </Box>
  );
};

export default MainScreenFilter;
